<template>
  <div id="article_container">
    <div class="artcol_top_bar" @click="goToArticleCollection">
      <span class="artcol_tip">文章收藏</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <div class="line_con">
      <span class="txt_label">文章地址：</span>
      <div class="add_in_con">
        <i class="el-icon-search"></i>
        <input class="add_in" placeholder="请输入文章地址" v-model="url" />
      </div>

      <button class="start_col_btn" @click="startCollection">开始收藏</button>
    </div>
    <div class="line_con">
      <span class="txt_label">进&emsp;&emsp;度：</span>
      <div class="add_in_con1">
        <el-progress
          :text-inside="true"
          :stroke-width="24"
          :percentage="collectionProcess"
          :status="collectionProcessStatus"
        ></el-progress>
      </div>
    </div>
    <div class="line_con">
      <span class="txt_label">选择分类：</span>
      <div class="add_in_con1 type_ses_con">
        <img src="../assets/add.png" class="add_img" @click="addClass" />
        <div class="type_ses_left_con">
          <select
            class="el-dropdown-link_left"
            v-model="firstLevelClassId"
            @change="changeFirstLevelClass"
          >
            <option
              v-for="item in firstLevelClass"
              :key="item.sortId"
              :value="item.sortId"
            >
              {{ item.sortName }}
            </option>
          </select>

          <select class="el-dropdown-link_right" v-model="secondLevelClassId">
            <option
              v-for="item in secondLevelClass"
              :key="item.sortId"
              :value="item.sortId"
            >
              {{ item.sortName }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="line_con">
      <span class="txt_label">添加标签：</span>
      <div class="add_in_con">
        <i class="el-icon-collection-tag"></i>
        <input class="add_in" placeholder="请输入标签" v-model="inputTag" />
      </div>

      <button class="start_col_btn" @click="addTag">添加</button>
    </div>

    <div class="line_con">
      <span class="txt_label">&emsp;&emsp;&emsp;&emsp;&emsp;</span>
      <div class="label_con_up">
        <div
          class="out_label_up"
          v-for="(tag, idx) in tags"
          :key="tag.labelName"
          :class="{ selected_up: tag.isselected_up }"
          @click="toggleTag(tag)"
          @mousemove="tag.isHover = true"
          @mouseleave="tag.isHover = false"
        >
          <div class="label_con_uptent_up">
            <div class="inlabel_up">{{ tag.labelName }}</div>
          </div>
          <span
            v-show="tag.isHover"
            class="delete-tag_up"
            @click.stop="deleteTag(tag, idx)"
            >×</span
          >
        </div>
      </div>
    </div>
    <div style="display: none">
      <div class="line_con">
        <span class="txt_label">正&emsp;&emsp;文：</span>
        <div class="add_in_con2">
          <VueUeditorWrap v-model="this.content" :config="this.myConfig" />
        </div>
      </div>
    </div>

    <div class="btns_con">
      <button style="margin-right: 50px" class="preview_btn" @click="save">
        保 存
      </button>
      <button class="preview_btn" @click="preview">预 览</button>
    </div>
  </div>
</template>

<script>
import {
  articleCollect,
  saveArticle,
  GetFirstLevelClassification,
  GetSecondLevelClassification,
  getAllTag,
  apiAddTag,
} from "@/api/article";
import * as dayjs from "dayjs";
import { url } from "@/api/request";
import { deleteLabel } from "@/api/label";

export default {
  name: "artcol",
  data() {
    return {
      collectionProcess: 0,

      firstLevelClass: [],
      firstLevelClassId: "",
      allSecondLevelClass: [],
      secondLevelClass: [],
      secondLevelClassId: "",
      articleId: -1,
      articleTitle: "",
      source: "",
      createTime: "",
      saveTime: "",
      content: "",
      url: "",
      tags: [],
      articleData: {},
      inputTag: "",
      collectionTime: null, // 收藏时间
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: "160%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: `${url}/kp/ueditor`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/ueditor/",
        readonly: true,
      },
      fileList: [],
      fileNameList: [],
      html: "",
    };
  },
  props: {
    clearDataBoolean: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    articleInfo() {
      return this.$store.getters.getArticleInfo;
    },
    collectionProcessStatus() {
      return this.collectionProcess == 100 ? "success" : "warning";
    },
  },

  mounted() {
    if (this.articleInfo.ing) {
      this.refreshClassification();
      // 将this.articleInfo赋值到页面data
      for (let key in this.articleInfo) {
        this[key] = this.articleInfo[key];
      }
      return;
    } else {
      this.clearFormData();
    }
    this.loadData(); // 调用方法获取标签
    this.refreshClassification();
  },
  methods: {
    /**
     * 刷新分类
     */
    refreshClassification() {
      let that = this;
      Promise.all([
        GetFirstLevelClassification({
          userId: this.userInfo.id,
        }),
        GetSecondLevelClassification({
          userId: this.userInfo.id,
        }),
      ])
        .then((responses) => {
          // responses[0] 是 GetFirstLevelClassification 的结果
          // responses[1] 是 GetSecondLevelClassification 的结果
          // 处理 GetFirstLevelClassification 的结果
          that.firstLevelClass.splice(0, that.firstLevelClass.length);
          that.firstLevelClassId = "";
          console.log("GetFirstLevelClassification Response:", responses[0]);
          responses[0].data.forEach((item) => {
            that.firstLevelClass.push(item);
          });

          // 处理 GetSecondLevelClassification 的结果
          that.allSecondLevelClass.splice(0, that.secondLevelClass.length);
          that.secondLevelClassId = "";
          console.log("GetSecondLevelClassification Response:", responses[1]);

          responses[1].data.forEach((item) => {
            that.allSecondLevelClass.push(item);
          });

          if (that.articleInfo.ing) {
            // 根据一级分类处理二级分类
            const arr = that.allSecondLevelClass.filter((item) => {
              return item.parentId == that.articleInfo.firstLevelClassId;
            });
            arr.forEach((item) => {
              that.secondLevelClass.push(item);
            });

            // 将this.articleInfo赋值到页面data
            for (let key in that.articleInfo) {
              that[key] = that.articleInfo[key];
              console.log(key);
            }
            for (var x of this.fileList) {
              this.fileNameList.push(x.raw.name);
              console.log(x.raw.name);
            }
          }
        })
        .catch((error) => {
          // 处理任一 promise 出错的情况
          console.error("Error in one of the promises:", error);
        });
    },

    goToArticleCollection() {
      // 使用 this.$router.push 实现路由跳转
      this.$router.push({ name: "artcol" });
      // 如果需要替换当前历史记录，可以使用 this.$router.replace
      // this.$router.replace('/path-to-article-collection');
    },
    async loadData() {
      try {
        await this.fetchTags();
        // 在这里调用其他需要异步加载的数据...
      } catch (error) {
        console.error("加载数据错误:", error);
      }
    },
    async fetchTags() {
      getAllTag({
        userId: this.userId,
      })
        .then((response) => {
          //console.log("ddd", response);
          const items = response.data;
          this.tags = [];
          // 创建包含 labelName 和 isselected_up 属性的对象数组
          console.log(items);
          this.tags = items.map((label) => ({
            ...label,
            isselected_up: false,
            isHover: false,
          }));
        })
        .catch((error) => {
          console.error("获取标签失败:", error);
        });
    },

    toggleTag(tagObj) {
      tagObj.isselected_up = !tagObj.isselected_up;
    },
    addTag() {
      if (!this.inputTag) {
        // 标签为空或已存在于 tags 中时不添加
        return;
      }
      const newTag = {
        labelId: NaN,
        labelName: this.inputTag,
        isselected_up: true,
      };

      apiAddTag(newTag)
        .then((res) => {
          newTag.labelId = res.data.labelId;
          this.tags.push(newTag); // 添加新的标签对象到 tags 数组
          this.inputTag = ""; // 清空输入框
        })
        .catch((e) => {
          console.error(e);
        });
    },

    /**
     * 开始收藏
     */
    startCollection() {
      if (!this.url) {
        this.$message.error("请输入文章地址");
        return;
      }
      // 周期定时器，每50ms增加this.collectionProcess，到99的时候不增加，由articleCollect.then()去控制到100
      this.collectionProcess = 0;
      this.collectionProcessInterval = setInterval(() => {
        if (this.collectionProcess >= 96) {
          clearInterval(this.collectionProcessInterval);
        }
        this.collectionProcess += 2;
      }, 50);
      articleCollect({
        userId: this.userId,
        url: this.url,
      })
        .then((res) => {
          clearInterval(this.collectionProcessInterval);
          this.articleId = res.data.articleId;
          this.articleTitle = res.data.articleTitle;
          this.content = res.data.content;
          this.source = res.data.source;
          this.createTime = res.data.publishTime;
          this.html = res.data.html;
          this.collectionTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          this.collectionProcess = 100;
          this.$message.success("收藏文章成功");
        })
        .catch((e) => {
          console.error(e);
          clearInterval(this.collectionProcessInterval);
          this.collectionProcess = 0;
        });
    },
    /**
     * 预览文章
     */
    preview() {
      const selected_tags = this.tags.filter((tag) => {
        return tag.isselected_up;
      });
      if (!this.articleTitle) {
        this.$alert("请先输入文章地址并点击开始收藏", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.firstLevelClassId || !this.secondLevelClassId) {
        this.$alert("请选择文章分类", "警告", {
          confirmButtonText: "确定",
        });
      } else if (selected_tags.length === 0) {
        this.$alert("请添加标签", "警告", {
          confirmButtonText: "确定",
        });
      } else {
        const formData = this.getFormData();
        console.log(formData);
        const fileList = this.articleInfo.fileList;
        console.log("sss", formData);
        this.$store.dispatch("recordData", { ...formData, fileList });
        this.$store.dispatch("recordData", this.getFormData());
        this.$router.push({ name: "artpre", params: { refresh: true } });
      }
    },
    save() {
      const selected_tags = this.tags.filter((tag) => {
        return tag.isselected_up;
      });
      if (!this.articleTitle) {
        this.$alert("请先输入文章地址并点击开始收藏", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.firstLevelClassId || !this.secondLevelClassId) {
        this.$alert("请选择文章分类", "警告", {
          confirmButtonText: "确定",
        });
      } else if (selected_tags.length === 0) {
        this.$alert("请添加标签", "警告", {
          confirmButtonText: "确定",
        });
      } else {
        saveArticle({
          articleId: this.articleId,
          articleTitle: this.articleTitle,
          content: this.content,
          html: this.html,
          collectionTime: this.collectionTime,
          firstSortId: this.firstLevelClassId,
          publishTime: this.createTime,
          secondSortId: this.secondLevelClassId,
          source: this.source,
          tagList: selected_tags,
          url: this.url,
          userId: this.userInfo.id,
          fileNameList: [],
        })
          .then((res) => {
            console.log(res);
            this.$message.success("保存文章成功");
            this.clearData();
            this.$store.dispatch("clearData");
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("保存文章失败");
          });
      }
    },

    changeFirstLevelClass() {
      this.secondLevelClass.splice(0, this.secondLevelClass.length);
      console.log(this.firstLevelClassId);
      const arr = this.allSecondLevelClass.filter(
        (item) => item.parentId == this.firstLevelClassId
      );
      arr.forEach((item) => {
        this.secondLevelClass.push(item);
      });
    },

    /**
     * 添加分类
     */
    addClass() {
      this.$store.dispatch("recordData", this.getFormData());
      // 跳转到分类管理页面，并通过params传值
      this.$router.push({ name: "clsmag", params: { back: true } });
    },

    deleteTag(tag, idx) {
      if (idx < 0 || idx >= this.tags.length) {
        return;
      }
      this.$alert("确定删除标签吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteLabel({
            labelId: tag.labelId,
          }).then(() => {
            this.tags.splice(idx, 1);
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },
    /**
     * 组装表单的数据
     */
    getFormData() {
      return {
        articleId: this.articleId,
        articleTitle: this.articleTitle,
        source: this.source,
        createTime: this.createTime,
        saveTime: this.saveTime,
        content: this.content,
        url: this.url,
        html: this.html,
        tags: this.tags,
        firstLevelClassId: this.firstLevelClassId,
        secondLevelClassId: this.secondLevelClassId,
        firstLevelClass: this.firstLevelClass,
        allSecondLevelClass: this.allSecondLevelClass,
        secondLevelClass: this.secondLevelClass,
        collectionTime: this.collectionTime,
        collectionProcess: this.collectionProcess,
        fileList: this.fileList,
      };
    },
    /**
     * 清楚页面数据
     */
    clearData() {
      this.articleTitle = "";
      this.source = "";
      this.createTime = "";
      this.saveTime = "";
      this.content = "";
      this.url = "";
      this.inputTag = "";
      this.firstLevelClassId = null;
      this.secondLevelClassId = null;
      this.tags.splice(0, this.tags.length);

      this.secondLevelClass.splice(0, this.secondLevelClass.length);
      this.collectionTime = null;
      this.collectionProcess = 0;
      this.fileList = [];
      this.fileNameList = [];
    },
    clearFormData() {
      this.articleTitle = "";
      this.source = "";
      this.createTime = "";
      this.saveTime = "";
      this.content = "";
      this.url = "";
      this.inputTag = "";
      // this.secondLevelClass.splice(0, this.secondLevelClass.length);
      this.collectionTime = null;
      this.collectionProcess = 0;
      this.tags.forEach((tag) => {
        tag.isselected_up = false;
      });
    },
  },
};
</script>

<style scoped>
.save_btn {
  background-image: url("../assets/save.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 60px;
}

.preview_btn {
  background-image: url("../assets/yulan.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.btns_con {
  margin-top: 60px;
  width: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inlabel {
  margin: 2px;
  background-color: #007ec3;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 16px;
  color: #fff6d5;
}

.out_label {
  border: solid 1px #008a9d;
  background-color: #fff6d5;
  cursor: pointer;
  margin-left: 10px;
}

.label_con {
  display: flex;
  align-items: center;
}

.el-dropdown-link_right {
  border: solid 2px #0187ea;
  color: #0187ea;
  flex: 1;
  display: block !important;
  margin-right: 10px;
  font-size: 18px;
}

.el-dropdown-link_left {
  border: solid 2px #0187ea;
  color: #0187ea;
  flex: 1;
  display: block !important;
  font-size: 18px;
  margin-right: 10px;
}

.type_ses_left_con {
  flex-grow: 2;
  display: flex;
  align-items: center;
}

.add_img {
  width: 21px;
  height: 21px;
}

.type_ses_con {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: white;
  border: none;
  cursor: pointer;
}

.add_in {
  min-width: 380px;
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.add_in::placeholder {
  font-size: 18px;
  color: #999999;
}

.add_in:focus {
  outline: none;
}

.add_in_con1 {
  width: 465px;
}

.add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.txt_label {
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.line_con {
  margin-top: 30px;
  display: flex;
  align-items: center;
}

.artcol_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.artcol_top_bar {
  display: flex;
  align-items: center;
}

.delete-tag_up {
  position: absolute;
  top: 0;
  right: 5px;
  /* 与标签文本的间距 */
  color: red;
  /* ×的颜色 */
  cursor: pointer;
  /* 鼠标悬停时的光标形状 */
  font-weight: bold;
  /* 字体加粗 */
  font-size: x-large;
}

.inlabel_up {
  margin: 2px;
  background-color: #007ec3;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
  color: #fff6d5;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

/* 标签容器样式 */
.label_con_up {
  display: flex;
  /* 使用 Flex 布局 */
  flex-wrap: wrap;
  /* 允许标签换行 */
  max-width: 85%;
  /* 确保容器不超出界面宽度 */
}

/* 单个标签的基本样式 */
.out_label_up {
  position: relative;
  display: inline-flex;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 5px 10px;
  background-color: #f0f0f0; /* 默认背景色 */
  border: 1px solid #ddd; /* 默认边框颜色 */
  border-radius: 4px; /* 圆角边框 */
  align-items: center;
  cursor: pointer;
  /* 移除宽度设置，使宽度根据内容自适应 */
}

/* 标签内容样式 */
.label_con_uptent_up {
  display: flex;
  align-items: center;
  justify-content: center; /* 确保文本水平居中 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  padding: 5px 10px; /* 内边距 */
  background-color: #f0f0f0; /* 背景颜色 */
  border-radius: 4px; /* 圆角边框 */
  /* 移除宽度设置，使宽度根据内容自适应 */
}

/* 选中标签的样式 */
.selected_up {
  color: #2f8dc0;
  background-color: #2f8dc0;
  border-right: 3px solid #2f8dc0; /* 深蓝色边框 */
  padding: 5px 10px; /* 增加内边距 */
  border-radius: 5px; /* 圆角 */
  transition:
    background-color 0.3s,
    border-color 0.3s; /* 平滑过渡 */
}

.selected_up:hover {
  background-color: #005e8a; /* 深蓝色背景 */
  border-color: #043148; /* 深蓝色边框 */
}
</style>
